import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import _ from 'lodash';
import { EUserRoles } from '../../models/user.model';

type Props = {
  value: EUserRoles;
  onChange?: (value: EUserRoles) => void;
  margin?: 'none' | 'dense' | 'normal' | undefined;
};

const UserRoleSelect = (props: Props) => {
  const dropdownItems = Object.values(EUserRoles);

  return (
    <FormControl fullWidth margin={props.margin}>
      <InputLabel>Role</InputLabel>
      <Select
        size="small"
        label="Role"
        value={props.value}
        onChange={(e) => {
          const item = dropdownItems.find((i) => i === e.target.value);
          if (item) {
            props.onChange?.(item);
          }
        }} // Handle select change here
        displayEmpty
        renderValue={(selected) => {
          return _.capitalize(_.words(selected).join(' '));
        }}
      >
        {dropdownItems.map((item) => (
          <MenuItem key={item} value={item}>
            {_.capitalize(_.words(item).join(' '))}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default UserRoleSelect;
